import { render, staticRenderFns } from "./MapProjectLocationsPanel.vue?vue&type=template&id=65b85368&scoped=true"
import script from "./MapProjectLocationsPanel.vue?vue&type=script&lang=js"
export * from "./MapProjectLocationsPanel.vue?vue&type=script&lang=js"
import style0 from "./MapProjectLocationsPanel.vue?vue&type=style&index=0&id=65b85368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b85368",
  null
  
)

export default component.exports